// src/pages/Index.tsx
import React, { useEffect, Suspense, lazy, useCallback, useState, useRef } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { useLenisScrollSnap } from "@/hooks/useLenisScrollSnap";

// Lazy-load below-the-fold sections
const Education = lazy(() => import("@/components/Education"));
const Experience = lazy(() => import("@/components/Experience"));
const Skills = lazy(() => import("@/components/Skills"));
const Projects = lazy(() => import("@/components/Projects"));
const Achievements = lazy(() => import("@/components/Achievements"));
const Youtube = lazy(() => import("@/components/Youtube"));

const SectionFallback = () => <div aria-hidden="true" style={{ minHeight: 600 }} />;

const Index: React.FC = () => {
  useLenisScrollSnap();

  return (
    <div className="min-h-screen bg-[#120f0d] text-foreground">
      <Navigation />

      <main>
        <Hero />
        <About />

        <Suspense fallback={<SectionFallback />}>
          <Education />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Experience />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Skills />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Projects />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Achievements />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Youtube />
        </Suspense>

        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default Index;
